module.exports = __webpack_public_path__ + "img/2022-04.c21f7dec.jpg";